import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, componentId, mobileIs } from "../../utils/siteUtils";
import { Icon } from "../../elements";
import PrimaryButton from "../../elements/primary-button";
import { scrollToSmoothTryMultipleTimes, scrollToSmoothTryMultipleTimesByDataSourceid } from "../../hooks/scrollToSmooth";
import "./style.scss";

const SubNavigation = props => {
	const { rendering, fields, params } = props;
	const { title, files, leftButtons, rightButtons } = fields;
	const isMobile = mobileIs()
	const rootNode = useRef()
	const [isScrolled, setIsScrolled] = useState(false);
	const lastScrollTop = useRef(0);
	const [activeIndex, setActiveIndex] = useState(-1);
	const [isOpen, setIsOpen] = useState(false);
	const menuRef = useRef(null);
	const navRef = useRef(null);
	const [htmlLang, setHtmlLang] = useState(null);
	useEffect(() => {
		setHtmlLang(document.documentElement.lang);
	})
	function isUUID(uuid) {
		let s = "" + uuid;
		s = s.match("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$");
		if (s === null) {
			return false;
		}
		return true;
	}

	const scrollToId = (cleanHash, index) => {
		setActiveIndex(index);
		if (cleanHash && isUUID(cleanHash)) {
			scrollToSmoothTryMultipleTimesByDataSourceid(`{${cleanHash.toUpperCase()}}`);
		} else if (cleanHash) {
			scrollToSmoothTryMultipleTimes(cleanHash);
		}
	}

	const downloadClk = (href,fileName) => {
		let a = document.createElement('a');
		a.setAttribute('href', `${href}?sc_lang=${htmlLang}`);
		a.download = `${fileName}.pdf`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	};
	useEffect(() => {
		const firstValidIndex = leftButtons.findIndex(
			(item) => item.fields?.buttonText?.value
		);
		if (activeIndex === -1 && firstValidIndex !== -1) {
			setActiveIndex(firstValidIndex);
		}
	}, [leftButtons, activeIndex]);
	useEffect(() => {
		if (rootNode.current) {
			const classList = rootNode.current.classList;
			const hasHideClass = classList.contains('hide-component');
			if (hasHideClass) {
				return null;
			}
			const handleScroll = () => {
				const header = document.querySelector('.header-container');
				const subNavigation = document.querySelector('.subNav');
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				header.querySelector('.header').style.background = '#000';

				setIsScrolled(scrollTop > 60);
				if (scrollTop > lastScrollTop.current && scrollTop > 100) {
					subNavigation.style.display = 'flex';
					setTimeout(() => {
						header.style.top = isMobile ? '-46px' : '-54px';
						header.style.transition = 'top 0.5s ease';
						subNavigation.style.top = '0';
					}, 400);
				}
				else if (scrollTop < lastScrollTop.current && scrollTop < 80) {
					header.style.top = '0';
					subNavigation.style.display = 'none';
					subNavigation.style.top = isMobile ? '40px' : '50px';
				}
				lastScrollTop.current = scrollTop <= 0 ? 0 : scrollTop;
			};
			const handleClickOutside = (event) => {
				if (menuRef.current && !menuRef.current.contains(event.target) && navRef.current && !navRef.current.contains(event.target)) {
					setIsOpen(false);
				}
			};
			window.addEventListener('scroll', handleScroll);
			document.addEventListener('click', handleClickOutside);
			return () => {
				window.removeEventListener('scroll', handleScroll);
				document.removeEventListener('click', handleClickOutside);
			};
		}
	}, []);
	const rootId = componentId(rendering);
	const rootClasses = classNames("subNav", getOverallSettingsClasses(fields));
	return (
		<div className={rootClasses} ref={rootNode} datasourceid={rendering.dataSource} id={rootId}>
			<div className="subNav__left">
				<Text tag="div" className="subNav__left-title" field={title} />
				<span className="subNav__left-line">|</span>
				<div className="subNav__left-buttons" >
					{!isMobile && (leftButtons && leftButtons.map((item, index) => (
						item.fields?.buttonText?.value && <div className={classNames("subNav__left-item", activeIndex === index ? 'active' : '')} key={index} onClick={(e) => scrollToId(item.fields?.anchorPoint?.id, index)}>
							<PrimaryButton {...(item.fields)} />
						</div>
					)))}
					{isMobile && (
						<div>
							{leftButtons && leftButtons[activeIndex]
								&& <div className="nav-title" onClick={() => setIsOpen(!isOpen)} ref={navRef}>
									<div className="subNav__left-item">
										<PrimaryButton {...(leftButtons[activeIndex].fields)} />
										<span id="ArrowTop" className={classNames("icon", { 'rotate': isOpen })}>
											<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="13" height="13"><path d="M208 913.792l90.496 90.528 497.792-497.824-4.32-4.32 4.352-4.352L298.496 0 208 90.56l411.648 411.616L208 913.792z"></path></svg>
										</span>
									</div>
								</div>
							}
							{isOpen &&
								<div className="menu" ref={menuRef}>
									<div className="menu-content">
										{leftButtons && leftButtons.map((item, index) => (
											item.fields?.buttonText?.value && <div className={classNames("subNav__left-item", activeIndex === index ? 'active' : '')} key={index} onClick={(e) => scrollToId(item.fields?.anchorPoint?.id, index)}>
												<PrimaryButton {...(item.fields)} />
											</div>
										))}
									</div>
								</div>
							}
						</div>
					)}
				</div>
			</div>

			<div className="subNav__right">
				<div className="subNav__right-download">
					{files && files.map((item, index) => (
					item.fields &&	<div className="download-icon" key={index}>
							{isMobile && <a download className="" href={item.fields?.file?.value?.src}>
								<Icon icon={{ ...item.fields.iconName.value }} />
							</a>}
							{!isMobile && <div className="" onClick={() => downloadClk(item.fields?.file?.value?.src,item.fields?.file?.value?.displayName)}>
								<PrimaryButton {...{
									colorScheme: item.fields.colorScheme,
									iconName: item.fields.iconName,
									buttonText: item.fields.buttonText,
								}} />
							</div>}
						</div>
					))}
				</div>
				<div className="subNav__right-buttons">
					{rightButtons && rightButtons.map((item, index) => (
						<div className={`subNav-button ${index !== rightButtons.length - 1 ? 'mobile-hide' : ''}`} key={index}>
							<PrimaryButton {...(item.fields)} />
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

export default SubNavigation;